import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import BootstrapTooltips from '../vendor/BootstrapTooltips';
import BootstrapModal from '../vendor/BootstrapModal';
import ChartJS from '../vendor/ChartJS';
import Klaro from '../vendor/Klaro';

// Scripts that will be used globally on the front.

// Common global scripts
require('./common');

// Vendor
BootstrapTooltips.init();
BootstrapTooltips.livewireRebind();
BootstrapModal.init();
ChartJS.init();
Klaro.init();
